export const ORDER_TABS = {
  ALL_ORDERS_TAB: 'الكل',
  CURRENT_ORDERS_TAB: 'الطلبات الحاليه',
  PREVIOUS_ORDERS_TAB: 'الطلبات السابقة',
  CHILD_ORDERS_TAB: 'الاستبدالات والاسترجاعات',
  FAILED_ORDERS_TAB: 'الطلبات الغير ناجحة',
};
